import React from "react";
import {Col, DatePicker, Input, Row} from "antd";
import {CompanyFilter, CourierFilter, SearchText, SubCompanyFilter} from "../../_defaultComponents/FilterComponents";
const {RangePicker} = DatePicker;

export const BackofficeSummaryFilter = ({filters, setFilters, datePickerProps}) => {
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={6} style={{marginBottom: 16}}>
                <div style={{marginBottom: 4, fontWeight: 500}}>Tarih Aralığı</div>
                <RangePicker
                    {...datePickerProps}
                    style={{minWidth: 0, width: "100%"}}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={4}>
                <CompanyFilter
                    value={filters.companyId}
                    onChange={value =>
                        setFilters({...filters, companyId: value, subcompanyId: undefined})
                    }
                    allowClear={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={4}>
                <SubCompanyFilter
                    value={filters.subcompanyId}
                    onChange={value => setFilters({...filters, subcompanyId: value})}
                    company={filters.companyId}
                    showSearch={true}
                    allowClear={true}
                    showAllOption={false}
                />
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={3} style={{marginBottom: 16}}>
                <div style={{marginBottom: 4, fontWeight: 500}}>Alıcı</div>
                <Input
                    placeholder="Alıcı adı"
                    value={filters.receiverName || ""}
                    onChange={e =>
                        setFilters({...filters, receiverName: e.target.value})
                    }
                    allowClear
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={3}>
                <div style={{marginBottom: 4, fontWeight: 500}}>Sipariş No</div>
                <Input
                    placeholder="Sipariş No"
                    value={filters.vigoOrderNumber || ""}
                    onChange={e =>
                        setFilters({...filters, vigoOrderNumber: e.target.value})
                    }
                    allowClear
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={4}>
                <CourierFilter
                    value={filters.courierId}
                    onChange={value => setFilters({...filters, courierId: value})}
                    allowClear={true}
                />
            </Col>
        </Row>
    );
};
